<template>
    <button type="button"
        class="btn btn-sm btn-primary" 
        data-toggle="modal" 
        @click="setRow"
        :data-target="'#'+modal">
        <i class="fas fa-edit"></i>
    </button>
</template>

<script>
export default {
    props: [
        'modal',
        'id',
    ],
    methods: {
        setRow() {
            this.$store.commit('setRowSelected', this.id);
        }
    }
}
</script>